export const MergeFilesModal: string = 'MergeFilesModal';
